import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Some photos",
  "description": "",
  "published": "2007-03-08T00:00:00.000Z",
  "redirect_from": ["/blog/some-photos/swizec/269"],
  "hero": "./img/76-414920956_a026e02177.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/7280946@N06/sets/72157594577683361/"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "375px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "133.18385650224215%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'533\\'%20viewBox=\\'0%200%20400%20533\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2014v15l2-3%204-2c1%201%202%200%204-4%201-3%202-4%204-4%202%201%2010-6%2010-8l1-2%207-5-16-1H0v14m191%2093l-5%201c-2-1-7%201-8%204-2%203-1%204%202%202h1l-3%202c-2%202-3%204-1%204%202%201%200%203-5%204-4%202-8%205-5%206%202%200%201%203-1%204l-1%202-4%2010-6%2013c-1%203-4%205-4%203s-3-3-7-3c-2%200-6%206-4%207%201%201%201%201-1%202v2l-1%208a713%20713%200%2000-8%2027l-4%205c-3%204-3%204-2%206%202%202%202%203%200%2013l-4%2012-11%2014c-9%2012-9%2012-13%2011l-4-1%202-11v-2c-1%200-2%201-2%203l-3%203v4c0%204%200%204-2%203-3-1-8-1-9%201l3%202%201%201v1l-1%201-2%203c-2%203-3%203-9%203h-6l5%201%206%202c0%202-1%206-3%208l-2%206-3%204-2%202-2-2-1-2c3%201%205%200%205-2l-4-1-4-1-1-3-1%202c1%202%202%2010%201%2012%200%201-1%201-1-1-1-1-1-1-1%202v1l-3%202c-5%205-15%203-11-2%202-2%202-5%200-5s-4%202-2%203v2c-4%200-9%206-14%2015a16943%2016943%200%2001-9%2020c3%200%202%203-7%2023a1226%201226%200%2000-9%2017l-1%2077v76h401v-77l-1-60v17l-7%205c-9%208-10%208-14%200a298%20298%200%2000-13-24c-3-1-5-8-4-12l-1-3c-2%202-2-6%201-9l1-3-8-5-11-6-6-7-5-10-1-3-4-10-2-3-4-10-4-10h-1c-1%201-1%201-1-1%201-1%200-2-2-4-3-3-4-4-1-3l-1-4-2-4-1-2-1-2-1-2c-1%200-2-1-1-2l-2-7c-4-6-4-7%201-11%204-4%204-4-1-8-5-3-5-4%200-8l4-4-8-6c-16-12-17-13-22-23-5-11-6-13-4-16%201-3-7-9-11-8l-2%202c1%201%200%203-2%205-2%203-2%203-4%201s1-7%207-9c3-1%202-5-6-22-3-6-4-10-3-10l1-2h-2c-1%202-1-1%202-10%202-6%202-7%201-7l-1%204c-1%204-4%208-5%206-1-3-11%201-10%204%200%203-2%202-5-2a104%20104%200%2000-9-11%20338%20338%200%2000-9-13l-6-1c-4%200-6-1-6-2l1-2c3%201%203%200%201-4-2-3-2-3-3-2-1%202-1%201-4-1s-2-4%201-2c2%202%203%200%201-2-3-2-5-3-5%200l-1%201v-3l-4%201m23%2035c3%204%206%2013%209%2025%201%208%204%2012%204%205l-2-4-1-5-2-9v-6c1-1%200-2-3-5-7-6-8-6-5-1m-53%2014l-3%207a548%20548%200%20001%2011c0-7%202-13%204-17%203-4%201-4-2-1m16%20126c-4%200-5%204-4%207v4l5%205c5%203%207%204%207%202h3c1%201%201%201%201-1v-6c1-3%201-4-1-6-2-3-6-6-8-6l-3%201M63%20311a2133%202133%200%2001-26%209l8%203c6%203%208%204%208%201l2-5%202-4%205%203c7%203%207%203%206%201l1-3c3-5%201-7-6-5M0%20457\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1803114e56ce04ca0072fa949c7ca72a/ca0a1/76-414920956_a026e02177.webp 223w", "/static/1803114e56ce04ca0072fa949c7ca72a/f3a60/76-414920956_a026e02177.webp 375w"],
                "sizes": "(max-width: 375px) 100vw, 375px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1803114e56ce04ca0072fa949c7ca72a/853b2/76-414920956_a026e02177.jpg 223w", "/static/1803114e56ce04ca0072fa949c7ca72a/bf173/76-414920956_a026e02177.jpg 375w"],
                "sizes": "(max-width: 375px) 100vw, 375px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1803114e56ce04ca0072fa949c7ca72a/bf173/76-414920956_a026e02177.jpg",
                "alt": "Brick church",
                "title": "Brick church",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Brick church`}</figcaption>{`
  `}</figure></a></p>
    <p>{`After not having been able to transfer photos from my cell phone to the computer I have discovered a way to do it today and immediately transfered some taht have been stacking up for a while. Many of them came out quite well considering the aparatus used to create them.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      